import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Backdrop, Button, CircularProgress, Grid, LinearProgress, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography, IconButton } from "@material-ui/core"
import { Autocomplete, createFilterOptions } from "@material-ui/lab"
import { DIYActions } from "../../../actions"
import SearchIcon from '@material-ui/icons/Search'

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff"
    },
    tablecellsmall: {
        padding: theme.spacing(0, 0.5, 0, 0.5),
        "&:last-child": {
            padding: theme.spacing(0, 0.5, 0, 0.5),
        }
    },
    tablenoborder: {
        border: "2px solid #212121",
    },
}))

const MenuProps = { PaperProps: { style: { backgroundColor: "#424242", maxHeight: 500, minWidth: 100, maxWidth: 350 } } }

const verifyPayload = (payload, checks = [], setMissing, override = {}) => {
    let _missing = {}
    checks.map((check) => {
        let matchCheck = override[check] === undefined ? "" : override[check]
        _missing[check] = payload[check] === matchCheck
    })
    setMissing(_missing)
    let validated = false
    Object.keys(_missing).map((key) => { if (validated == false) validated = _missing[key] })
    return !validated
}

const CreateNewTicketDesktopMode = ({ profile, form, missing, metadata, setForm, sitenameFilterProps, onSubmit, onCancel }) => {

    const siteSearch = () => {
        DIYActions.Ticket.searchsite(form.sitename).then((response) => {
            const data = response.data.data
            sitenameFilterProps.setSitenames(response.data.data)
            setForm({
                ...form,
                sitename: data.sitename ? data.sitename : "",
                region: data.region ? data.region : "NOVAL",
                market: data.market ? data.market : "NOVAL",
                falocation: data.falocation ? data.falocation : data.locationcode ? data.locationcode : ""
            })
        }).catch(() => sitenameFilterProps.setSitenames([]))
    }

    const faLocationSearch = () => {
        DIYActions.Ticket.searchfalocation(form.falocation).then((response) => {
            const data = response.data.data
            sitenameFilterProps.setSitenames(response.data.data)
            setForm({
                ...form,
                sitename: data.sitename ? data.sitename : "",
                region: data.region ? data.region : "NOVAL",
                market: data.market ? data.market : "NOVAL",
                falocation: data.falocation ? data.falocation : data.locationcode ? data.locationcode : ""
            })
        }).catch(() => sitenameFilterProps.setSitenames([]))
    }

    console.log(form)

    return (
        metadata.status === "SUCCESS" && profile.accounttype !== "B2B" ? (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Sitename*: </Typography></Grid>
                                <Grid item style={{ width: "600px" }}>
                                    {
                                        profile.accounttype === "FCO" ? (
                                            <Autocomplete
                                                id="sitename options"
                                                disableClearable
                                                disableListWrap
                                                value={form.sitename}
                                                inputValue={form.sitename}
                                                {...(String(form.sitename).length >= 3 ? { options: sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename)) } : { options: sitenameFilterProps.sitenames })}
                                                // options={sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename))}
                                                filterOptions={createFilterOptions({ ignoreCase: true, trim: true })}
                                                onChange={(_, newValue) => setForm({ ...form, sitename: newValue })}
                                                // onInputChange={(_, newInput) => DIYActions.Ticket.searchsite(newInput).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))}
                                                renderInput={(params) => <TextField {...params} fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />}
                                            />
                                        ) : (
                                            <TextField fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />
                                        )
                                    }
                                </Grid>
                                <Grid item><IconButton size='small' disabled={form.sitename.length === 0} onClick={siteSearch}><SearchIcon /></IconButton></Grid>
                            </Grid>
                        </Grid>
                        {
                            profile.accounttype !== "FCO" ? (
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item><Typography variant="h6" color="textSecondary">FA Location*: </Typography></Grid>
                                        <Grid item style={{ width: "300px" }}>
                                            <TextField fullWidth size="small" variant="outlined" error={missing.falocation} value={form.falocation} onChange={(event) => setForm({ ...form, falocation: event.target.value })} />
                                        </Grid>
                                        <Grid item><IconButton size='small' disabled={form.falocation.length === 0} onClick={faLocationSearch}><SearchIcon /></IconButton></Grid>
                                    </Grid>
                                </Grid>
                            ) : null
                        }
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Customer*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}><Typography variant="h6" color="textSecondary">{form.customer}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "75px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Region*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.region} value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Region</MenuItem>
                                        {metadata.data.regions.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "100px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Market*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.market} value={form.market} onChange={(e) => setForm({ ...form, market: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Market</MenuItem>
                                        {metadata.data.markets.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {
                    profile.accounttype === "FCO" ? (
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: "80px" }}><Typography variant="h6" color="textSecondary" align="right">Verizon Tracking#: </Typography></Grid>
                                        <Grid item><TextField fullWidth size="small" variant="outlined" error={missing.verizon_tracking} value={form.verizon_tracking} onChange={(e) => setForm({ ...form, verizon_tracking: e.target.value })} /></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: "180px" }}><Typography variant="h6" color="textSecondary" align="right">Hardware Serial #: </Typography></Grid>
                                        <Grid item><TextField fullWidth size="small" variant="outlined" error={missing.hardware_serial} value={form.hardware_serial} onChange={(e) => setForm({ ...form, hardware_serial: e.target.value })} /></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: "195px" }}><Typography variant="h6" color="textSecondary" align="right">Radio: </Typography></Grid>
                                        <Grid item>
                                            <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.radio} value={form.radio} onChange={(e) => setForm({ ...form, radio: e.target.value })}>
                                                <MenuItem key="NOVAL" value="NOVAL">Select Radio</MenuItem>
                                                {metadata.data.radios.map((radio) => <MenuItem key={radio} value={radio}><Typography variant="h6" color="textSecondary">{radio}</Typography></MenuItem>)}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : null
                }
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        {
                            metadata.data.reasons.length === 1 ? (
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item><Typography variant="h6" color="textSecondary">Reason for request*:</Typography></Grid>
                                        <Grid item style={{ width: "600px" }}>
                                            <Typography variant="h6" color="textSecondary">{form.reason_for_ticket}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item><Typography variant="h6" color="textSecondary">Reason for request*:</Typography></Grid>
                                        <Grid item style={{ minWidth: "200px", maxWidth: "600px" }}>
                                            <Select fullWidth MenuProps={MenuProps} error={missing.reason_for_ticket} value={form.reason_for_ticket} onChange={(e) => setForm({ ...form, reason_for_ticket: e.target.value })}>
                                                <MenuItem key="NOVAL" value="NOVAL">Select Reason</MenuItem>
                                                {metadata.data.reasons.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Typography variant="h6" color="textSecondary">Comments: </Typography></Grid>
                        <Grid item style={{ width: "60vw" }}>
                            <TextField fullWidth multiline rows={7} rowsMax={10} size="small" variant="outlined" error={missing.comments} value={form.comments} onChange={(e) => setForm({ ...form, comments: e.target.value })} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Button size="small" variant="contained" color="primary" onClick={() => onSubmit()}><Typography variant="h6" color="textSecondary">SUBMIT</Typography></Button></Grid>
                        <Grid item><Button size="small" variant="contained" color="secondary" onClick={() => onCancel()}><Typography variant="h6" color="textSecondary">CANCEL</Typography></Button></Grid>
                    </Grid>
                </Grid>
            </Grid>
        ) : metadata.status === "SUCCESS" && profile.accounttype === "B2B" && metadata.data.blocked ? (
            <Typography variant="h4" color="textSecondary">Account Setup is not completed. Please contact Application Admin</Typography>
        ) : metadata.status === "SUCCESS" && profile.accounttype === "B2B" && !metadata.data.blocked ? (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Customer*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}><Typography variant="h6" color="textSecondary">{form.customer}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "75px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Reason for request*:</Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.reason_for_ticket} value={form.reason_for_ticket} onChange={(e) => setForm({ ...form, reason_for_ticket: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Reason</MenuItem>
                                        {metadata.data.reasons.map((reason) => <MenuItem key={reason.SupportTypeCode} value={reason.SupportTypeCode}><Typography variant="h6" color="textSecondary">{reason.SupportTypeDisplay}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Sitename*: </Typography></Grid>
                                <Grid item style={{ width: "300px" }}>
                                    <TextField fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "100px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Region*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.region} value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Region</MenuItem>
                                        {metadata.data.regions.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "100px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Market*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.market} value={form.market} onChange={(e) => setForm({ ...form, market: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Market</MenuItem>
                                        {metadata.data.markets.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Typography variant="h6" color="textSecondary">Comments: </Typography></Grid>
                        <Grid item style={{ width: "60vw" }}>
                            <TextField fullWidth multiline rows={7} rowsMax={10} size="small" variant="outlined" error={missing.comments} value={form.comments} onChange={(e) => setForm({ ...form, comments: e.target.value })} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Button size="small" variant="contained" color="primary" onClick={() => onSubmit()}><Typography variant="h6" color="textSecondary">SUBMIT</Typography></Button></Grid>
                        <Grid item><Button size="small" variant="contained" color="secondary" onClick={() => onCancel()}><Typography variant="h6" color="textSecondary">CANCEL</Typography></Button></Grid>
                    </Grid>
                </Grid>
            </Grid>
        ) : metadata.status === "WORKING" ? (
            <LinearProgress />
        ) : metadata.status === "ERROR" ? (
            <Typography variant="h4" color="textSecondary">Service Unavailable. Please try again later</Typography>
        ) : null
    )
}

const CreateNewTicketSystemMode = ({ profile, form, missing, metadata, setForm, sitenameFilterProps, onSubmit, onCancel }) => {
    const siteSearch = () => {
        DIYActions.Ticket.searchsite(form.sitename).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
    }
    const faLocationSearch = () => {
        DIYActions.Ticket.searchfalocation(form.falocation).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
    }
    return (
        metadata.status === "SUCCESS" && profile.accounttype !== "B2B" ? (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Sitename*: </Typography></Grid>
                                <Grid item style={{ width: "600px" }}>
                                    {
                                        profile.accounttype === "FCO" ? (
                                            <Autocomplete
                                                id="sitename options"
                                                disableClearable
                                                disableListWrap
                                                value={form.sitename}
                                                inputValue={form.sitename}
                                                {...(String(form.sitename).length >= 3 ? { options: sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename)) } : { options: sitenameFilterProps.sitenames })}
                                                // options={sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename))}
                                                filterOptions={createFilterOptions({ ignoreCase: true, trim: true })}
                                                onChange={(_, newValue) => setForm({ ...form, sitename: newValue })}
                                                // onInputChange={(_, newInput) => DIYActions.Ticket.searchsite(newInput).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))}
                                                renderInput={(params) => <TextField {...params} fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />}
                                            />
                                        ) : (
                                            <TextField fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />
                                        )
                                    }
                                </Grid>
                                <Grid item><IconButton size='small' disabled={form.sitename.length === 0} onClick={siteSearch}><SearchIcon /></IconButton></Grid>
                            </Grid>
                        </Grid>
                        {
                            profile.accounttype === "FCO" ? (
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item><Typography variant="h6" color="textSecondary">FA Location*: </Typography></Grid>
                                        <Grid item style={{ width: "300px" }}>
                                            <TextField fullWidth size="small" variant="outlined" error={missing.falocation} value={form.falocation} onChange={(event) => setForm({ ...form, falocation: event.target.value })} />
                                        </Grid>
                                        <Grid item><IconButton size='small' disabled={form.falocation.length === 0} onClick={faLocationSearch}><SearchIcon /></IconButton></Grid>
                                    </Grid>
                                </Grid>
                            ) : null
                        }
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Customer*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}><Typography variant="h6" color="textSecondary">{form.customer}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "75px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Region*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.region} value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Region</MenuItem>
                                        {metadata.data.regions.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Market*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.market} value={form.market} onChange={(e) => setForm({ ...form, market: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Market</MenuItem>
                                        {metadata.data.markets.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {
                    profile.accounttype === "FCO" ? (
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: "80px" }}><Typography variant="h6" color="textSecondary" align="right">Verizon Tracking#: </Typography></Grid>
                                        <Grid item><TextField fullWidth size="small" variant="outlined" error={missing.verizon_tracking} value={form.verizon_tracking} onChange={(e) => setForm({ ...form, verizon_tracking: e.target.value })} /></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: "180px" }}><Typography variant="h6" color="textSecondary" align="right">Hardware Serial #: </Typography></Grid>
                                        <Grid item><TextField fullWidth size="small" variant="outlined" error={missing.hardware_serial} value={form.hardware_serial} onChange={(e) => setForm({ ...form, hardware_serial: e.target.value })} /></Grid>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                        <Grid item style={{ width: "195px" }}><Typography variant="h6" color="textSecondary" align="right">Radio: </Typography></Grid>
                                        <Grid item>
                                            <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.radio} value={form.radio} onChange={(e) => setForm({ ...form, radio: e.target.value })}>
                                                <MenuItem key="NOVAL" value="NOVAL">Select Radio</MenuItem>
                                                {metadata.data.radios.map((radio) => <MenuItem key={radio} value={radio}><Typography variant="h6" color="textSecondary">{radio}</Typography></MenuItem>)}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    ) : null
                }
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Reason for request*:</Typography></Grid>
                                <Grid item style={{ width: "560px" }}>
                                    {
                                        metadata.data.reasons.length === 1 ? <Typography variant="h6" color="textSecondary">{form.reason_for_ticket}</Typography> : (
                                            <Select fullWidth MenuProps={MenuProps} error={missing.reason_for_ticket} value={form.reason_for_ticket} onChange={(e) => setForm({ ...form, reason_for_ticket: e.target.value })}>
                                                <MenuItem key="NOVAL" value="NOVAL">Select Reason</MenuItem>
                                                {metadata.data.reasons.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                            </Select>
                                        )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Typography variant="h6" color="textSecondary">Comments: </Typography></Grid>
                        <Grid item style={{ width: "60vw" }}>
                            <TextField fullWidth multiline rows={7} rowsMax={10} size="small" variant="outlined" error={missing.comments} value={form.comments} onChange={(e) => setForm({ ...form, comments: e.target.value })} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Button size="small" variant="contained" color="primary" onClick={() => onSubmit()}><Typography variant="h6" color="textSecondary">SUBMIT</Typography></Button></Grid>
                        <Grid item><Button size="small" variant="contained" color="secondary" onClick={() => onCancel()}><Typography variant="h6" color="textSecondary">CANCEL</Typography></Button></Grid>
                    </Grid>
                </Grid>
            </Grid>
        ) : metadata.status === "SUCCESS" && profile.accounttype === "B2B" && metadata.data.blocked ? (
            <Typography variant="h4" color="textSecondary">Account Setup is not completed. Please contact Application Admin</Typography>
        ) : metadata.status === "SUCCESS" && profile.accounttype === "B2B" && !metadata.data.blocked ? (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Customer*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}><Typography variant="h6" color="textSecondary">{form.customer}</Typography></Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "75px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Reason for request*:</Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.reason_for_ticket} value={form.reason_for_ticket} onChange={(e) => setForm({ ...form, reason_for_ticket: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Reason</MenuItem>
                                        {metadata.data.reasons.map((reason) => <MenuItem key={reason.SupportTypeCode} value={reason.SupportTypeCode}><Typography variant="h6" color="textSecondary">{reason.SupportTypeDisplay}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Sitename*: </Typography></Grid>
                                <Grid item style={{ width: "300px" }}>
                                    <TextField fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item style={{ paddingLeft: "100px" }}>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Region*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.region} value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Region</MenuItem>
                                        {metadata.data.regions.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item><Typography variant="h6" color="textSecondary">Market*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <Select style={{ width: "200px" }} MenuProps={MenuProps} error={missing.market} value={form.market} onChange={(e) => setForm({ ...form, market: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select Market</MenuItem>
                                        {metadata.data.markets.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Typography variant="h6" color="textSecondary">Comments: </Typography></Grid>
                        <Grid item style={{ width: "60vw" }}>
                            <TextField fullWidth multiline rows={7} rowsMax={10} size="small" variant="outlined" error={missing.comments} value={form.comments} onChange={(e) => setForm({ ...form, comments: e.target.value })} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item><Button size="small" variant="contained" color="primary" onClick={() => onSubmit()}><Typography variant="h6" color="textSecondary">SUBMIT</Typography></Button></Grid>
                        <Grid item><Button size="small" variant="contained" color="secondary" onClick={() => onCancel()}><Typography variant="h6" color="textSecondary">CANCEL</Typography></Button></Grid>
                    </Grid>
                </Grid>
            </Grid>
        ) : metadata.status === "WORKING" ? (
            <LinearProgress />
        ) : metadata.status === "ERROR" ? (
            <Typography variant="h4" color="textSecondary">Service Unavailable. Please try again later</Typography>
        ) : null
    )
}

const CreateNewTicketTabletMode = ({ profile, form, missing, metadata, setForm, sitenameFilterProps, onSubmit, onCancel }) => {
    const siteSearch = () => {
        DIYActions.Ticket.searchsite(form.sitename).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
    }
    const faLocationSearch = () => {
        DIYActions.Ticket.searchfalocation(form.falocation).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
    }
    return (
        metadata.status === "SUCCESS" ? (
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Sitename*: </Typography></Grid>
                        <Grid item style={{ width: "250px" }}>
                            {
                                profile.accounttype === "FCO" ? (
                                    <Autocomplete
                                        id="sitename options"
                                        disableClearable
                                        disableListWrap
                                        value={form.sitename}
                                        inputValue={form.sitename}
                                        {...(String(form.sitename).length >= 3 ? { options: sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename)) } : { options: sitenameFilterProps.sitenames })}
                                        // options={sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename))}
                                        filterOptions={createFilterOptions({ ignoreCase: true, trim: true })}
                                        onChange={(event) => setForm({ ...form, sitename: sitenameFilterProps.sitenames[event.target.value] })}
                                        // onInputChange={(_, newInput) => DIYActions.Ticket.searchsite(newInput).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))}
                                        renderInput={(params) => <TextField {...params} fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />}
                                    />
                                ) : (
                                    <TextField fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />
                                )
                            }
                        </Grid>
                        <Grid item><IconButton size='small' disabled={form.sitename.length === 0} onClick={siteSearch}><SearchIcon /></IconButton></Grid>
                    </Grid>
                </Grid>
                {
                    profile.accounttype === "FCO" ? (
                        <Grid item>
                            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">FA Location*: </Typography></Grid>
                                <Grid item style={{ width: "250px" }}>
                                    <TextField fullWidth size="small" variant="outlined" error={missing.falocation} value={form.falocation} onChange={(event) => setForm({ ...form, falocation: event.target.value })} />
                                </Grid>
                                <Grid item><IconButton size='small' disabled={form.falocation.length === 0} onClick={faLocationSearch}><SearchIcon /></IconButton></Grid>
                            </Grid>
                        </Grid>
                    ) : null
                }

                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Customer*: </Typography></Grid>
                        <Grid item style={{ width: "250px" }}><Typography variant="h6" color="textSecondary">{form.customer}</Typography></Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Region*: </Typography></Grid>
                        <Grid item style={{ width: "250px" }}>
                            <Select fullWidth MenuProps={MenuProps} error={missing.region} value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}>
                                <MenuItem key="NOVAL" value="NOVAL">Select Region</MenuItem>
                                {metadata.data.regions.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Market*: </Typography></Grid>
                        <Grid item style={{ width: "250px" }}>
                            <Select fullWidth MenuProps={MenuProps} error={missing.market} value={form.market} onChange={(e) => setForm({ ...form, market: e.target.value })}>
                                <MenuItem key="NOVAL" value="NOVAL">Select Market</MenuItem>
                                {metadata.data.markets.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
                {
                    profile.accounttype === "FCO" ? (
                        <React.Fragment>
                            <Grid item>
                                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                    <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Radio*: </Typography></Grid>
                                    <Grid item style={{ width: "250px" }}>
                                        <Select fullWidth MenuProps={MenuProps} error={missing.radio} value={form.radio} onChange={(e) => setForm({ ...form, radio: e.target.value })}>
                                            <MenuItem key="NOVAL" value="NOVAL">Select Radio</MenuItem>
                                            {metadata.data.radios.map((radio) => <MenuItem key={radio} value={radio}><Typography variant="h6" color="textSecondary">{radio}</Typography></MenuItem>)}
                                        </Select>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                    <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Verizon Tracking #*: </Typography></Grid>
                                    <Grid item style={{ width: "250px" }}><TextField fullWidth size="small" variant="outlined" error={missing.verizon_tracking} value={form.verizon_tracking} onChange={(e) => setForm({ ...form, verizon_tracking: e.target.value })} /></Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                                    <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Hardware Serial #*: </Typography></Grid>
                                    <Grid item style={{ width: "250px" }}><TextField fullWidth size="small" variant="outlined" error={missing.hardware_serial} value={form.hardware_serial} onChange={(e) => setForm({ ...form, hardware_serial: e.target.value })} /></Grid>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    ) : null
                }
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Reason for request: </Typography></Grid>
                        <Grid item style={{ width: "300px" }}>
                            {
                                metadata.data.reasons.length === 1 ? <Typography variant="h6" color="textSecondary">{form.reason_for_ticket}</Typography> : (
                                    <Select fullWidth MenuProps={MenuProps} error={missing.reason_for_ticket} value={form.reason_for_ticket} onChange={(e) => setForm({ ...form, reason_for_ticket: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select reason</MenuItem>
                                        {metadata.data.reasons.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                )
                            }
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                        <Grid item style={{ width: "150px" }}><Typography variant="h6" color="textSecondary">Comments: </Typography></Grid>
                        <Grid item style={{ width: "60vw" }}><TextField fullWidth multiline rows={7} rowsMax={10} size="small" variant="outlined" error={missing.comments} value={form.comments} onChange={(e) => setForm({ ...form, comments: e.target.value })} /></Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={2}>
                        <Grid item><Button size="small" variant="contained" color="primary" onClick={() => onSubmit()}><Typography variant="h6" color="textSecondary">SUBMIT</Typography></Button></Grid>
                        <Grid item><Button size="small" variant="contained" color="secondary" onClick={() => onCancel()}><Typography variant="h6" color="textSecondary">CANCEL</Typography></Button></Grid>
                    </Grid>
                </Grid>
            </Grid>
        ) : metadata.status === "WORKING" ? (
            <LinearProgress />
        ) : metadata.status === "ERROR" ? (
            <Typography variant="h4" color="textSecondary">Service Unavailable. Please try again later</Typography>
        ) : null
    )
}

const CreateNewTicketMobileMode = ({ profile, form, missing, metadata, setForm, sitenameFilterProps, onSubmit, onCancel }) => {
    const siteSearch = () => {
        DIYActions.Ticket.searchsite(form.sitename).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
    }
    const faLocationSearch = () => {
        DIYActions.Ticket.searchfalocation(form.falocation).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
    }
    const classes = useStyles()
    return (
        metadata.status === "SUCCESS" ? (
            <TableContainer>
                <Table size="small">
                    <TableBody>
                        <TableRow><TableCell className={classes.tablenoborder}>
                            {
                                profile.accounttype === "FCO" ? (
                                    <Autocomplete
                                        id="sitename options"
                                        disableClearable
                                        disableListWrap
                                        value={form.sitename}
                                        inputValue={form.sitename}
                                        {...(String(form.sitename).length >= 3 ? { options: sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename)) } : { options: sitenameFilterProps.sitenames })}
                                        // options={sitenameFilterProps.sitenames.filter((item) => String(item).includes(form.sitename))}
                                        filterOptions={createFilterOptions({ ignoreCase: true, trim: true })}
                                        onChange={(event) => setForm({ ...form, sitename: sitenameFilterProps.sitenames[event.target.value] })}
                                        // onInputChange={(_, newInput) => DIYActions.Ticket.searchsite(newInput).then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))}
                                        renderInput={(params) => <TextField {...params} fullWidth size="small" variant="outlined" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />}
                                    />
                                ) : (
                                    <TextField fullWidth size="small" variant="outlined" label="Sitename" error={missing.sitename} value={form.sitename} onChange={(event) => setForm({ ...form, sitename: event.target.value })} />
                                )
                            }
                        </TableCell>
                            <TableCell className={classes.tablenoborder}>
                                <IconButton size='small' disabled={form.sitename.length === 0} onClick={siteSearch}><SearchIcon /></IconButton>
                            </TableCell>
                        </TableRow>
                        {
                            profile.accounttype === "FCO" ? (
                                <TableRow><TableCell className={classes.tablenoborder}>
                                    <TextField fullWidth size="small" variant="outlined" label="FA Location" error={missing.falocation} value={form.falocation} onChange={(event) => setForm({ ...form, falocation: event.target.value })} />
                                </TableCell>
                                    <TableCell className={classes.tablenoborder}>
                                        <IconButton size='small' disabled={form.falocation.length === 0} onClick={faLocationSearch}><SearchIcon /></IconButton>
                                    </TableCell>
                                </TableRow>
                            ) : null
                        }

                        <TableRow><TableCell className={classes.tablenoborder}>
                            <Typography variant="h6" color="textSecondary">Customer: {form.customer}</Typography>
                        </TableCell></TableRow>
                        <TableRow><TableCell className={classes.tablenoborder}>
                            <Select fullWidth MenuProps={MenuProps} error={missing.region} value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })}>
                                <MenuItem key="NOVAL" value="NOVAL">Select Region</MenuItem>
                                {metadata.data.regions.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                            </Select>
                        </TableCell></TableRow>
                        <TableRow><TableCell className={classes.tablenoborder}>
                            <Select fullWidth MenuProps={MenuProps} error={missing.market} value={form.market} onChange={(e) => setForm({ ...form, market: e.target.value })}>
                                <MenuItem key="NOVAL" value="NOVAL">Select Market</MenuItem>
                                {metadata.data.markets.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                            </Select>
                        </TableCell></TableRow>
                        {
                            profile.accounttype === "FCO" ? (
                                <React.Fragment>
                                    <TableRow><TableCell className={classes.tablenoborder}>
                                        <Select fullWidth MenuProps={MenuProps} error={missing.radio} value={form.radio} onChange={(e) => setForm({ ...form, radio: e.target.value })}>
                                            <MenuItem key="NOVAL" value="NOVAL">Select Radio</MenuItem>
                                            {metadata.data.radios.map((radio) => <MenuItem key={radio} value={radio}><Typography variant="h6" color="textSecondary">{radio}</Typography></MenuItem>)}
                                        </Select>
                                    </TableCell></TableRow>
                                    <TableRow><TableCell className={classes.tablenoborder}>
                                        <TextField fullWidth size="small" variant="outlined" label="Verizon Tracking #" error={missing.verizon_tracking} value={form.verizon_tracking} onChange={(e) => setForm({ ...form, verizon_tracking: e.target.value })} />
                                    </TableCell></TableRow>
                                    <TableRow><TableCell className={classes.tablenoborder}>
                                        <TextField fullWidth size="small" variant="outlined" label="Hardware Serial #" error={missing.hardware_serial} value={form.hardware_serial} onChange={(e) => setForm({ ...form, hardware_serial: e.target.value })} />
                                    </TableCell></TableRow>
                                </React.Fragment>
                            ) : null
                        }
                        <TableRow><TableCell className={classes.tablenoborder}>
                            {
                                metadata.data.reasons.length === 1 ? <Typography variant="h6" color="textSecondary">{form.reason_for_ticket}</Typography> : (
                                    <Select fullWidth MenuProps={MenuProps} error={missing.reason_for_ticket} value={form.reason_for_ticket} onChange={(e) => setForm({ ...form, reason_for_ticket: e.target.value })}>
                                        <MenuItem key="NOVAL" value="NOVAL">Select reason</MenuItem>
                                        {metadata.data.reasons.map((reason) => <MenuItem key={reason} value={reason}><Typography variant="h6" color="textSecondary">{reason}</Typography></MenuItem>)}
                                    </Select>
                                )
                            }
                        </TableCell></TableRow>
                        <TableRow><TableCell className={classes.tablenoborder}>
                            <TextField fullWidth multiline label="Comments*" rows={4} rowsMax={6} size="small" variant="outlined" error={missing.comments} value={form.comments} onChange={(e) => setForm({ ...form, comments: e.target.value })} />
                        </TableCell></TableRow>
                        <TableRow>
                            <TableCell className={classes.tablenoborder}>
                                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                                    <Grid item><Button size="small" variant="contained" color="primary" onClick={() => onSubmit()}><Typography variant="h6" color="textSecondary">SUBMIT</Typography></Button></Grid>
                                    <Grid item><Button size="small" variant="contained" color="secondary" onClick={() => onCancel()}><Typography variant="h6" color="textSecondary">CANCEL</Typography></Button></Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        ) : metadata.status === "WORKING" ? (
            <LinearProgress />
        ) : metadata.status === "ERROR" ? (
            <Typography variant="h4" color="textSecondary">Service Unavailable. Please try again later</Typography>
        ) : null
    )
}

const CreateNewTicket = ({ profile, responsive, back }) => {
    const classes = useStyles()
    const [form, setForm] = React.useState({ sitename: "", customer: profile.customer, region: "NOVAL", market: "NOVAL", reason_for_ticket: "NOVAL", comments: "", falocation: "", verizon_tracking: "", hardware_serial: "", radio: "NOVAL" })
    const [missing, setMissing] = React.useState({ sitename: false, customer: false, region: false, market: false, reason_for_ticket: false, comments: false, falocation: false, ...(profile.accounttype === "FCO" ? { verizon_tracking: false, hardware_serial: false, radio: false } : {}) })
    const [metadata, setMetadata] = React.useState({ status: "NEW", data: { reasons: [], regions: [], markets: [], blocked: false, radios: [] } })
    const [responseStatus, setResponseStatus] = React.useState("NEW")
    const [sitenameFilterOpen, setSitenameFilterOpen] = React.useState(false)
    const [sitenames, setSitenames] = React.useState([])
    const sitenameFilter = React.useRef(null)

    React.useEffect(() => {
        setMetadata({ 'status': 'WORKING', 'data': { reasons: [] } })
        DIYActions.Ticket.getMetadata().then((response) => {
            setMetadata(response.data)
            if (response.data.data.reasons.length === 1) {
                setForm({ ...form, reason_for_ticket: response.data.data.reasons[0] })
            }
        }).catch((error) => {
            setMetadata({ 'status': 'ERROR', 'data': { reasons: [] } })
        })
        if (profile.accounttype === "FCO") {
            DIYActions.Ticket.searchsite("").then((response) => sitenameFilterProps.setSitenames(response.data.data)).catch(() => sitenameFilterProps.setSitenames([]))
        }
    }, [])

    var sitenameFilterProps = { sitenames: sitenames, setSitenames: setSitenames }

    const viewProps = {
        profile,
        form,
        missing,
        metadata,
        sitenameFilterProps,
        setForm,
        onSubmit: () => {
            var payload = {
                sitename: form.sitename,
                customer: form.customer,
                region: form.region,
                market: form.market,
                reason_for_ticket: form.reason_for_ticket.split("|")[1].trim(),
                comments: form.comments,
                tickettype: form.reason_for_ticket.split("|")[0].trim()
            }
            var payloadVerified = false
            if (profile.accounttype === "FCO") {
                payload = { ...payload, verizon_tracking: form.verizon_tracking, hardware_serial: form.hardware_serial, radio: form.radio }
                payloadVerified = verifyPayload(payload, ["sitename", "customer", "region", "market", "reason_for_ticket", "comments", "verizon_tracking", "hardware_serial", "radio"], setMissing, { reason_for_ticket: "NOVAL", region: "NOVAL", market: "NOVAL", radio: "NOVAL" })
            } else if (profile.accounttype === "B2B") {
                metadata.data.reasons.map((reason) => {
                    if (reason.SupportTypeCode === payload.reason_for_ticket) {
                        payload = { ...payload, tickettype: profile.accounttype + "|" + reason.SupportNameCode + "|" + reason.SupportTypeCode + "|" + reason.SupportProcessorType }
                    }
                })
                payloadVerified = verifyPayload(payload, ["sitename", "customer", "region", "market", "reason_for_ticket", "comments"], setMissing, { reason_for_ticket: "NOVAL", region: "NOVAL", market: "NOVAL" })
            } else {
                payloadVerified = verifyPayload(payload, ["sitename", "customer", "region", "market", "reason_for_ticket", "comments"], setMissing, { reason_for_ticket: "NOVAL", region: "NOVAL", market: "NOVAL" })
            }
            if (payloadVerified) {
                setResponseStatus("WORKING")
                DIYActions.Ticket.onSubmit(payload).then((response) => setResponseStatus(response.data.status)).catch((error) => setResponseStatus('ERROR'))
            }
        },
        onCancel: () => {
            setForm({ sitename: "", customer: profile.customer, region: "NOVAL", market: "NOVAL", reason_for_ticket: "NOVAL", comments: "", falocation: "" })
            setMissing({ sitename: false, customer: false, region: false, market: false, reason_for_ticket: false, comments: false, falocation: false })
        }
    }

    const done = () => {
        viewProps.onCancel()
        back()
    }

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault()
            setSitenameFilterOpen(false)
        }
    }

    const prevOpen = React.useRef(sitenameFilterOpen)
    React.useEffect(() => {
        if (prevOpen.current === true && sitenameFilterOpen === false && ![undefined, null].includes(sitenameFilter) && ![undefined, null].includes(sitenameFilter.current)) {
            sitenameFilter.current.focus()
        }
        prevOpen.current = sitenameFilterOpen
    }, [sitenameFilterOpen])

    return (
        <React.Fragment>
            {responsive.isMobile ? <CreateNewTicketMobileMode {...viewProps} /> : responsive.isTablet ? <CreateNewTicketTabletMode {...viewProps} /> : responsive.isSystem ? <CreateNewTicketSystemMode {...viewProps} /> : <CreateNewTicketDesktopMode {...viewProps} />}
            <Backdrop className={classes.backdrop} open={responseStatus !== "NEW"}>
                {
                    responseStatus === "WORKING" ? (
                        <React.Fragment>
                            <CircularProgress color="inherit" />
                            <Typography variant="h5" color="textSecondary" style={{ marginLeft: 5 }}>Creating you ticket. Please wait...</Typography>
                        </React.Fragment>
                    ) : responseStatus === "SUCCESS" ? (
                        <React.Fragment>
                            <Typography variant="h5" color="textSecondary">Ticket Created</Typography>
                            <Button variant="contained" size="small" color="primary" style={{ marginLeft: 5 }} onClick={() => done()}><Typography variant="h5" color="textSecondary">OK</Typography></Button>
                        </React.Fragment>
                    ) : responseStatus === "ERROR" ? (
                        <React.Fragment>
                            <Typography variant="h5" color="textSecondary">Something went wrong. Please try again</Typography>
                            <Button variant="contained" size="small" color="primary" style={{ marginLeft: 5 }} onClick={() => setResponseStatus("NEW")}><Typography variant="h5" color="textSecondary">RETRY</Typography></Button>
                        </React.Fragment>
                    ) : null
                }
            </Backdrop>
        </React.Fragment>
    )
}

export default CreateNewTicket
